/**
 * Enum dos níveis de visualização do resultado/lucratividade do pedido
 */
export enum EnumNivelVisualizacaoResultadoPedido {
  SemAcesso = 0,
  QualidadeDeValor = 1,
  DRP = 2,
  DRPCustos = 3,
}

/** Nome e descrição de cada nível */
export const NIVEL_VISUALIZACAO_RESULTADO_PEDIDO_DESCRIPTIONS: Record<
  EnumNivelVisualizacaoResultadoPedido,
  { nome: string; descricao: string }
> = {
  [EnumNivelVisualizacaoResultadoPedido.SemAcesso]: {
    nome: 'Sem Acesso',
    descricao: 'Usuário não terá acesso a nenhuma visualização de resultado ou lucratividade',
  },
  [EnumNivelVisualizacaoResultadoPedido.QualidadeDeValor]: {
    nome: 'Qualidade de Valor',
    descricao:
      'Usuário poderá visualizar apenas informações de qualidade de valor, como grupo de rentabilidade',
  },
  [EnumNivelVisualizacaoResultadoPedido.DRP]: {
    nome: 'Qualidade de Valor + DRP',
    descricao:
      'Usuário poderá visualizar qualidade de valor e DRP resumido com apenas margem de lucro',
  },
  [EnumNivelVisualizacaoResultadoPedido.DRPCustos]: {
    nome: 'Qualidade de Valor + DRP + Custos',
    descricao:
      'Usuário poderá visualizar qualidade de valor com DRP completo contendo toda a composição de custos',
  },
};
